import React, { Fragment } from "react";
import SpeciesForm from "./form/SpeciesForm";
import PageContentWrapper from "../../../components/wrappers/PageContentWrapper";
import { Divider, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import SingleSpeciesFlip from "./components/SingleSpeciesFlip";
import Loader from "../../../components/loader/Loader";
import ErrorFullScreenMessage from "../../../components/fullScreenMessage/ErrorFullScreenMessage";
import useSpecies from "./hooks/useSpecies";
import { useIsMobile } from "../../../utils/Functions";

//Master view for mangaing species
export default function SpeciesPage() {
  const { t } = useTranslation();
  const { data, isLoading, error } = useSpecies();
  const isMobile = useIsMobile();
  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return <ErrorFullScreenMessage />;
  }

  return (
    <PageContentWrapper>
      <Fragment>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
          }}
        >
          <Typography variant={isMobile ? "h5" : "h3"} fontWeight="bold">
            {t("SpeciesManagement")}
          </Typography>
        </Box>
        <SpeciesForm />
      </Fragment>
      {data?.map((ent, index) => (
        <SingleSpeciesFlip species={ent} key={ent?.id} />
      ))}
    </PageContentWrapper>
  );
}
